import * as yup from "yup";

export type StepInputEmailOTPSchema = {
  email: string;
  code: string;
};

export const StepInputEmailOTPSchema: yup.ObjectSchema<StepInputEmailOTPSchema> = yup.object({
  email: yup.string().required().email(),
  code: yup.string().required().min(6).max(6),
});
